import cxs from 'cxs';
import { COLOURS, FONT_WEIGHTS, FONT_SIZES } from '../../../common/styles/vars';

export const TAG = cxs({
  alignItems: 'center',
  backgroundColor: COLOURS.cyan.jungleGreen.monkey,
  borderRadius: '3px',
  display: 'inline-flex',
  justifyContent: 'center',
  padding: '1px 8px 0 8px',
  height: '25px',

  ' > p': {
    color: COLOURS.grey.athens.parthenon,
    fontWeight: FONT_WEIGHTS.medium,
    fontSize: FONT_SIZES.small,
    padding: 0,
    overflow: 'hidden',
    margin: 'auto',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'block',
    lineHeight: '14px',
    userSelect: 'none'
  }
});

export const DISABLED_TAG = cxs({
  background: COLOURS.grey.mischka.michael,

  ' > p': {
    color: COLOURS.grey.denim
  }
});

export const INVALID_TAG = cxs({
  background: COLOURS.red.redApple
});

export const ICON = cxs({
  marginLeft: '10px',
  outlineColor: 'white !important',
  outlineWidth: 'thin',

  ':focus': {
    outlineStyle: 'solid'
  }
});